export const getters = {
  accessToken: state => state.accessToken,
  userReference: state => state.userReference,
  displayName: state => state.displayName,
  userProfileImageUrl: state => state.photoURL,
  userTrackingProfileStatus: state => state.userTrackingProfileStatus
}
